import { getStore, removeStore, setStore } from "@/util/store";
import { foodmacMacruntimeWorkorderFindworkorderstatisticlist } from "@/api/hb-work-order/common";

const storePurchaseOrder = {
    state: {
     // 门店订货单详情
     storePurchaseOrderDetailsBaseMsg:{},
     
    },
    actions: {
    setStorePurchaseOrderDetails({ commit }, data) {
      commit("SET_STORE_PURCHASE_ORDER_DETAILS", data);
    },
    clearStorePurchaseOrderDetails({ commit }) {
      commit("CLEAR_STORE_PURCHASE_ORDER_DETAILS");
    }
    },
    mutations: {
    SET_STORE_PURCHASE_ORDER_DETAILS(state, payload) {
      state.storePurchaseOrderDetailsBaseMsg = payload || {};
    },
    CLEAR_STORE_PURCHASE_ORDER_DETAILS(state) {
      state.storePurchaseOrderDetailsBaseMsg = {};
    }
    }
  }; 
  export default storePurchaseOrder